module.exports = __webpack_public_path__ + "img/21.ceaac0b8.jpeg";